export default __webpack_public_path__ + "static/art_gallery-d795ccce9c84b4faf23ca43c7fe25c26.png";